import { useSessionValue } from '@portal/appLayer/auth';
import { Metafield } from '@portal/gql/shopifyStorefront/graphql';
import { useCallback, useMemo } from 'react';

export function useAGZAccount() {
  const session = useSessionValue();

  const recheckSession = useCallback(() => {
    let isAgzAccount = false;
    let hasReceivedAgz = false;

    if (session?.customer) {
      const { customer } = session;

      const customerHasTagsProperty = Object.prototype.hasOwnProperty.call(customer, 'tags');
      const customerHasAGZTag = customer.tags?.includes('AGZ') ?? false;
      isAgzAccount = customerHasTagsProperty && customerHasAGZTag;

      const metafield = customer.metafields?.find(
        (mf: Metafield) => mf.key === 'agz_welcome_box_received'
      );

      hasReceivedAgz = metafield?.value === true || metafield?.value === 'true';
    }
    return { isAgzAccount, hasReceivedAgz };
  }, [session]);

  const { isAgzAccount, hasReceivedAgz } = useMemo(() => recheckSession(), [recheckSession]);

  return { recheckSession, isAgzAccount, hasReceivedAgz };
}
